// extracted by mini-css-extract-plugin
export var externalLink = "_cj-0";
export var internalLinkLabel = "_cj-1";